
import { PartyEvent } from '../../model/PartyEvent'
import { VersionInfo } from '../../model/VersionInfo'
import { http } from '../../utils/http'

export interface SavePartyEventDto {
    id: number
    title: string
    location: string
    userEmail: string
    start: string | null
    end: string | null
}

export const getPartyEventsAsync = async (
    userEmail: string,
    token: string
) : Promise<PartyEvent[]> => {
    const result = await http<undefined, PartyEvent[]>({
        path: `PartyEvents?email=${userEmail}`,
        accessToken: token
    })
    if (result.ok && result.parsedBody) {
        return result.parsedBody || []
    }
    return []
}

export const insertPartyEventAsync = async (
    partyEvent: SavePartyEventDto,
    token: string
) : Promise<PartyEvent | null>  => {
    const result = await http<SavePartyEventDto, PartyEvent>({
        method: 'post',
        path: 'PartyEvents',
        accessToken: token,
        body: partyEvent
    })
    if (result.ok && result.parsedBody) {
        return result.parsedBody || null
    }
    return null
}

export const deletePartyEventAsync = async (
    partyEventId: number,
    userEmail: string,
    token: string
) : Promise<boolean> => {
    const result = await http<undefined, undefined>({
        method: 'delete',
        path: `PartyEvents?partyEventId=${partyEventId}&email=${userEmail}`,
        accessToken: token
    })
    if (result.ok && result.parsedBody) {
        return result.parsedBody || null
    }
    return result.ok
}

export const getBackEndVersionNumberAsync = async (
    token: string
) : Promise<string> => {
    const result = await http<undefined, VersionInfo>({
        path: 'Version',
        accessToken: token
    })
    if (result.ok && result.parsedBody) {
        return result.parsedBody.versionNumber || ''
    }
    return ''
}
